import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  Chip,
  CkTextEditor,
  FormFieldSet,
  LogoLoader,
  PageHeader,
  PageTitle,
  showToast,
  useFormHandler,
} from "../../../../../components";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
const MOCK_USERS = [
  { id: 1, name: "Vikranth", email: "Vikranth12@gmail.com" },
  { id: 2, name: "Mohsin", email: "Mohsintek12@gmail.com" },
  { id: 3, name: "Chandan", email: "Chandan12@gmail.com" },
  { id: 4, name: "Ershad", email: "Ershad12@gmail.com" },
  { id: 5, name: "Astha", email: "Astha12@gmail.com" },
  { id: 6, name: "Vijaya", email: "Vijaya12@gmail.com" },
  { id: 7, name: "Shiva", email: "Shiva12@gmail.com" },
  { id: 8, name: "Poojitha", email: "Poojitha12@gmail.com" },
  { id: 9, name: "Kiran", email: "Kiran12@gmail.com" },
];
const NOTIFICATION_CHANNELS = [
  { label: "Email", value: "email" },
  { label: "In App", value: "inApp" },
];
const CreateNotification = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isEdit: stateIsEdit, data } = useLocation().state || {};
  const isEdit = searchParams.get("mode") === "edit" || stateIsEdit;
  const [loading, setLoading] = useState(false);
  const defaultValues = {
    eventName: "",
    triggerEvent: "",
    status: 1,
    oneTimeNotification: false,
    recuringNotification: false,
    notificationType: [],
    remainderDays: "",
    customDates: [],
    customDateInput: "",
    recipients: [],
    customEmail: "",
    channels: NOTIFICATION_CHANNELS.reduce(
      (acc, channel) => ({ ...acc, [channel.value]: false }),
      {},
    ),
    emailContent: "",
  };
  // Validation Rules
  const checkValids = {
    eventName: { required: true },
    triggerEvent: { required: true },
    recipients: { required: true, type: "select", multiple: true },
    emailContent: { required: true },
  };
  // Memoize form handler
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValues, checkValids);
  // Pre-fill form when in edit mode
  useEffect(() => {
    if (isEdit && data) {
      setFormData({
        _id: data._id || null,
        eventName: data.category || "",
        triggerEvent: data.trigger || "",
        status: data.status || false,
        oneTimeNotification: data.oneTimeNotification || false,
        recuringNotification: data.recuringNotification || false,
        notificationType: data.notificationType || [],
        remainderDays: data.remainderDays || "",
        customDates: data.customDates || [],
        recipients: data.recipients || [],
        channels:
          data.channels ||
          NOTIFICATION_CHANNELS.reduce(
            (acc, channel) => ({ ...acc, [channel.value]: false }),
            {},
          ),
        emailContent: data.emailContent || "",
      });
    }
  }, [isEdit, data, setFormData]);
  const handleBack = () => {
    navigate(-1);
  };
  const handleSaveNotification = async () => {
    console.log(formData);
    const isValid = validateAllFields();
    if (!isValid) return;
    const payload = {
      category: formData.eventName,
      trigger: formData.triggerEvent,
      status: formData.status,
      oneTimeNotification: formData.oneTimeNotification,
      recuringNotification: formData.recuringNotification,
      notificationType: formData.notificationType,
      remainderDays: formData.remainderDays,
      customDates: formData.customDates,
      recipients: formData.recipients,
      channels: formData.channels,
      emailContent: formData.emailContent,
    };
    try {
      setLoading(true);
      if (isEdit && formData.id) {
        // Update existing notification
        console.log("Updating notification:", formData.id, payload);
        // TODO: dispatch(updateNotificationStart({ id: formData.id, ...payload }));
        showToast("Notification updated successfully!", "success", 2000);
      } else {
        // Create new notification
        console.log("Creating new notification:", payload);
        // TODO: dispatch(createNotificationStart(payload));
        showToast("Notification created successfully!", "success", 2000);
        setFormData(defaultValues);
      }
      navigate(-1);
    } catch (error) {
      console.error("Error saving notification:", error);
      const errorMsg = typeof error === "string" ? error : "An error occurred";
      showToast(errorMsg, "error", 2000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-full rounded-lg shadow-lg flex flex-col">
      <PageHeader
        Section={
          <div className="flex items-center gap-2 my-2">
            <Button
              type="icon"
              icon="arrow_back"
              variant="text"
              onClick={handleBack}
              color="black"
            />
            <PageTitle
              title={
                isEdit
                  ? "Edit Notification Center"
                  : "Create Notification Center"
              }
              tag="h5"
            />
          </div>
        }
      />
      <div className="mx-6 mb-6 inner-section overflow-y-auto">
        <div className="pt-2 px-6 pb-6 flex flex-col gap-3">
          {/* Basic Information */}
          <div className="flex flex-col gap-1">
            <PageHeader
              Section={
                <PageTitle
                  title="Basic Information"
                  tag="h6"
                  className="text-primary"
                />
              }
            />
            <div className="flex items-start gap-8 w-full mt-1">
              <div className="w-1/4">
                <FormFieldSet
                  title="Event Name"
                  type="select"
                  placeholder="Select"
                  options={[
                    {
                      label: "Employee Lifetime Notifications",
                      value: "employee_lifetime_notifications",
                    },
                    {
                      label: "Immigration & Compliance Notifications",
                      value: "immigration_compliance_notifications",
                    },
                    {
                      label: "Placement & Assignment Notifications",
                      value: "placement_assignment_notifications",
                    },
                    {
                      label: "Payroll & Compensation Notifications",
                      value: "payroll_compensation_notifications",
                    },
                    {
                      label: "Timesheet & Attendance Notifications",
                      value: "custom_notifications",
                    },
                  ]}
                  value={formData.eventName}
                  error={errors.eventName}
                  onChange={(val) => handleChange("eventName", val)}
                  size="md"
                />
              </div>
              <div className="w-1/4">
                <FormFieldSet
                  title="Trigger Event"
                  type="select"
                  placeholder="Select"
                  options={[
                    { label: "On Due Date", value: "on_due_date" },
                    { label: "On Creation", value: "on_creation" },
                  ]}
                  value={formData.triggerEvent}
                  onChange={(val) => handleChange("triggerEvent", val)}
                  size="md"
                  error={errors.triggerEvent}
                />
              </div>
              <div className="flex items-center gap-3">
                <FormFieldSet
                  title="Status"
                  type="toggle"
                  isChecked={formData.status === 1}
                  onChange={(val) => handleChange("status", val ? 1 : 2)}
                />
              </div>
            </div>
          </div>
          {/* Timelines Settings */}
          <div className="flex flex-col gap-1">
            <PageHeader
              Section={
                <PageTitle
                  title="Timelines Settings"
                  tag="h6"
                  className="text-primary"
                />
              }
            />
            <div className="flex items-center gap-4">
              <FormFieldSet
                noTitle
                type="checkbox"
                options={[{ label: "One Time Notification", value: "oneTime" }]}
                values={formData.oneTimeNotification ? ["oneTime"] : []}
                onChange={(vals) => {
                  const isChecked = vals.includes("oneTime");
                  handleChange("oneTimeNotification", isChecked);
                  if (isChecked) handleChange("recuringNotification", false);
                }}
                multiple={true}
                size="md"
              />
              <FormFieldSet
                noTitle
                type="checkbox"
                options={[
                  { label: "Recurring Notification", value: "recurring" },
                ]}
                values={formData.recuringNotification ? ["recurring"] : []}
                onChange={(vals) => {
                  const isChecked = vals.includes("recurring");
                  handleChange("recuringNotification", isChecked);
                  if (isChecked) handleChange("oneTimeNotification", false);
                }}
                multiple={true}
                size="md"
              />
            </div>
            {formData.recuringNotification && (
              <div className="flex items-end gap-4 w-full mt-2">
                <div className="w-1/4">
                  <FormFieldSet
                    title="Notification Timing"
                    type="checkbox"
                    options={[
                      { label: "Pre", value: "pre" },
                      { label: "Post", value: "post" },
                    ]}
                    values={formData.notificationType}
                    onChange={(vals) => handleChange("notificationType", vals)}
                    size="md"
                  />
                </div>
              </div>
            )}
            {formData.recuringNotification && (
              <div className="flex items-start gap-4 w-full mt-2">
                <div className="w-1/4">
                  <FormFieldSet
                    title="Remainder Days"
                    type="select"
                    placeholder="Select"
                    options={[
                      { label: "Once", value: "once" },
                      { label: "Daily", value: "daily" },
                      { label: "Weekly", value: "weekly" },
                      { label: "Monthly", value: "monthly" },
                      { label: "Quarterly", value: "quarterly" },
                    ]}
                    value={formData.remainderDays}
                    onChange={(val) => handleChange("remainderDays", val)}
                    size="md"
                  />
                </div>
                <div className="w-1/4">
                  <FormFieldSet
                    title="Enter Custom Dates"
                    type="number"
                    placeholder="Enter day & press Enter"
                    value={formData.customDateInput}
                    onChange={(val) => handleChange("customDateInput", val)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const day = parseInt(formData.customDateInput, 10);
                        if (
                          !isNaN(day) &&
                          day > 0 &&
                          !(formData.customDates || []).includes(day)
                        ) {
                          handleChange("customDates", [
                            ...(formData.customDates || []),
                            day,
                          ]);
                        }
                        handleChange("customDateInput", "");
                      }
                    }}
                    size="md"
                  />
                </div>
                <div className="flex flex-wrap items-center gap-2 mt-7">
                  {(formData.customDates || []).map((day) => (
                    <Chip
                      key={day}
                      label={`${day}`}
                      onDelete={() =>
                        handleChange(
                          "customDates",
                          formData.customDates.filter((d) => d !== day),
                        )
                      }
                      size="sm"
                      color="info"
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          {/* Add Recipient */}
          <div className="flex flex-col gap-1">
            <PageHeader
              Section={
                <PageTitle
                  title="Add Recipient"
                  tag="h6"
                  className="text-primary"
                />
              }
            />
            <div className="flex flex-col gap-4">
              {/* Internal Recipients Row */}
              <div className="flex items-end gap-4 w-full">
                <div className="w-1/4">
                  <FormFieldSet
                    noTitle
                    type="select"
                    multiple={true}
                    placeholder="Add People, groups"
                    options={MOCK_USERS.map((u) => ({
                      label: u.name,
                      value: u.name,
                    }))}
                    value={formData.recipients.filter((r) =>
                      MOCK_USERS.some((u) => u.name === r)
                    )}
                    onChange={(selectedUsers) => {
                      const customEmails = formData.recipients.filter(
                        (r) => !MOCK_USERS.some((u) => u.name === r)
                      );
                      handleChange("recipients", [
                        ...customEmails,
                        ...selectedUsers,
                      ]);
                    }}
                    showSearch={true}
                    error={errors.recipients}
                    size="md"
                  />
                </div>
                <div className="flex-1 flex items-center gap-2 flex-wrap mb-2">
                  {formData.recipients
                    .filter((r) => MOCK_USERS.some((u) => u.name === r))
                    .map((name, index) => (
                      <Chip
                        key={`internal-${index}`}
                        label={name}
                        onDelete={() => {
                          handleChange(
                            "recipients",
                            formData.recipients.filter((r) => r !== name),
                          );
                        }}
                        size="md"
                        variant="contained"
                        color="info"
                        className="text-info-500 border-info-300"
                      />
                    ))}
                </div>
              </div>

              {/* Custom Emails Row */}
              <div className="flex items-end gap-4 w-full">
                <div className="w-1/4">
                  <FormFieldSet
                    title="Add Custom Email"
                    type="text"
                    placeholder="Enter email & press Enter"
                    value={formData.customEmail}
                    onChange={(val) => handleChange("customEmail", val)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        const email = formData.customEmail.trim();
                        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                        if (
                          email &&
                          emailRegex.test(email) &&
                          !formData.recipients.includes(email)
                        ) {
                          handleChange("recipients", [
                            ...formData.recipients,
                            email,
                          ]);
                          handleChange("customEmail", "");
                        } else if (email && !emailRegex.test(email)) {
                          showToast(
                            "Please enter a valid email",
                            "error",
                            2000,
                          );
                        }
                      }
                    }}
                    error={errors.customEmail}
                    size="md"
                  />
                </div>
                <div className="flex-1 flex items-center gap-2 flex-wrap mb-1">
                  {formData.recipients
                    .filter((r) => !MOCK_USERS.some((u) => u.name === r))
                    .map((email, index) => (
                      <Chip
                        key={`custom-${index}`}
                        label={email}
                        onDelete={() => {
                          handleChange(
                            "recipients",
                            formData.recipients.filter((r) => r !== email),
                          );
                        }}
                        size="md"
                        variant="contained"
                        color="info"
                        className="text-info-500 border-info-300"
                      />
                    ))}
                </div>
              </div>
            </div>
          </div>
          {/* Channels */}
          <div className="flex flex-col gap-1">
            <PageHeader
              Section={
                <PageTitle title="Channels" tag="h6" className="text-primary" />
              }
            />
            <div className="flex gap-8">
              {NOTIFICATION_CHANNELS.map((channel) => (
                <FormFieldSet
                  key={channel.value}
                  noTitle
                  type="checkbox"
                  options={[channel]}
                  values={
                    formData.channels[channel.value] ? [channel.value] : []
                  }
                  onChange={(vals) =>
                    handleChange("channels", {
                      ...formData.channels,
                      [channel.value]: vals.includes(channel.value),
                    })
                  }
                  multiple={true}
                  size="md"
                />
              ))}
            </div>
          </div>

          {/* Email Content */}
          <div className="flex flex-col gap-1">
            <PageHeader
              Section={
                <PageTitle
                  title="Email Content"
                  tag="h6"
                  className="text-primary"
                />
              }
            />
            <CkTextEditor
              value={formData.emailContent}
              onChange={(val) => handleChange("emailContent", val)}
              height="200px"
              placeholder="Type your email content here..."
            />
            {errors.emailContent && (
              <span className="text-danger-300 text-xs mt-1">
                {errors.emailContent}
              </span>
            )}
          </div>
        </div>

        <div className="p-4 flex justify-end gap-3">
          <Button
            title="Cancel"
            variant="outlined"
            color="primary"
            onClick={handleBack}
          />
          <Button
            title="Save"
            variant="contained"
            color="primary"
            onClick={handleSaveNotification}
          />
        </div>
      </div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default CreateNotification;
